<template>
  <div :class="ismobile ? 'workdetail' : 'workdetailmo'">
    <div class="address">
      <img class="icons" src="../static/address_icon.png" alt="" />
      您所在的位置：热招职位 > {{ works.name }}
    </div>
    <!-- 头部卡片 -->
    <div class="detail_main">
      <div class="tops">
        <div class="tops_div">
          <img
            class="topimg"
            :src="'https://hcrl.huicairen.net' + works.img"
            alt=""
          />
        </div>
        <div class="tops_right">
          <div class="top_foot">
            <div>
              <div class="title">{{ works.name }}</div>
              <div class="money">
                平均工资：<span style="color: #da251c; font-weight: bold">{{
                  works.salary
                }}</span
                >元/月
              </div>
            </div>
            <div class="ewms">
              <img
                class="ewm_icon"
                src="https://okgo.top/163660064337356.png?imageMogr2/thumbnail/172x9998%3E/quality/90!"
                alt=""
              />
              微信扫码报名
            </div>
          </div>
          <div class="label_list">
            <div v-for="item in works.flag" :key="item" class="labels">
              {{ item }}
            </div>
          </div>
          <div class="top_foot">
            <div>
              <div class="item_left">
                <img class="left_icon" src="../static/yaoqiu_icon.png" alt="" />
                要求：{{ works.recruit }}
              </div>
              <div class="item_left">
                <img class="left_icon" src="../static/dizhi_icon.png" alt="" />
                地址：{{ works.address }}
              </div>
            </div>
            <div class="online" @click="centerDialogVisible = true">
              在线报名
            </div>
          </div>
        </div>
      </div>
      <!-- 职位详情 -->
      <div class="works">
        <div v-for="item in list" :key="item.name">
          <div class="work_top">
            <img class="top_img" :src="item.src" alt="" />{{ item.name }}
          </div>
          <div class="lis">
            {{ item.text }}
          </div>
          <!-- <ul>
            <li class="lis" v-for="(item, index) in namelist" :key="index">
              {{ index + 1 }}.{{ item }}
            </li>
          </ul> -->
        </div>
      </div>
      <!-- 入职流程 -->
      <div class="liuc">
        <div class="work_top">
          <img
            class="top_img"
            src="../static/icon_position_liu_ico.png"
            alt=""
          />入职流程
        </div>
        <img src="../static/position_liucheng_bg.png" class="liuc_img" alt="" />
      </div>
      <!-- 推荐职位 -->
      <div class="liuc">
        <div class="work_top">
          <img
            class="top_img"
            src="../static/icon_position_tuij_ico.png"
            alt=""
          />推荐职位
        </div>
        <div class="tj_list">
          <div class="tj_item" v-for="item in moreList" :key="item.id">
            <img
              class="tj_img"
              :src="'https://hcrl.huicairen.net' + item.img"
              alt=""
            />
            <div class="item_foot">
              <div class="name">{{ item.name }}</div>
              <div class="money">
                平均工资：<span style="color: #da251c">{{ item.salary }}</span>
                元/月
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 报名弹窗 -->
    <el-dialog
      title=""
      :visible.sync="centerDialogVisible"
      :width="ismobile ? '530px' : '265px'"
      center
    >
      <div class="baomings">
        <div class="title">入职报名表单</div>
        <div class="p2">我们是正规渠道，直接招聘入职</div>
        <div>
          <input
            class="inp"
            v-model="name"
            type="text"
            name=""
            id=""
            placeholder="您的姓名"
          />
        </div>
        <div>
          <input
            class="inp"
            v-model="phone"
            type="text"
            name=""
            id=""
            placeholder="您的电话"
          />
        </div>
        <div class="submits" @click="submits">提交表单</div>
      </div>
    </el-dialog>
    <!-- 提交弹窗 -->
    <el-dialog
      title="申请免费入职"
      :visible.sync="issubmits"
      :width="ismobile ? '360px' : '200px'"
      center
      top="250px"
    >
      <div style="texts">
        {{ text }}
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
        <el-button
          style="background-color: #da251c; color: #fff"
          @click="issubmits = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      text: "您的报名信息已提交，我们的招聘顾问会尽快与您 取得联系！",
      name: "",
      phone: "",
      issubmits: false,
      centerDialogVisible: false,
      moreList: [],
      works: {},
      list: [
        {
          name: "招聘要求",
          src: require("../static/icon_position_zp_ico.png"),
        },
        {
          name: "岗位说明",
          src: require("../static/icon_position_shuo_ico.png"),
        },
        {
          name: "薪资福利",
          src: require("../static/icon_position_fuli_ico.png"),
        },
        {
          name: "食宿介绍",
          src: require("../static/icon_position_shi_ico.png"),
        },
      ],

      windowWidth: document.documentElement.clientWidth,
    };
  },
  computed: {
    ismobile() {
      console.log(this.windowWidth);
      if (this.windowWidth > 500) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
  methods: {
    submits() {
      if (!this.name || !this.phone) {
        this.$message.error("请输入完整的信息");
        return;
      }
      this.$api
        .position({
          name: this.name,
          tel: this.phone,
          flag: 1,
          position_id: this.$route.query.id,
        })
        .then((data) => {
          console.log(data);
          if (data.data.code == 0) {
            this.text =
              "您的报名信息已提交，我们的招聘顾问会尽快与您 取得联系！";
          } else {
            this.text = data.data.msg;
          }
          this.issubmits = true;
        });
    },
    moredata() {
      this.$api.getPosition().then((data) => {
        console.log(data);
        if (data.data.code == 0) {
          this.moreList = data.data.data;
        } else {
          this.$message({
            message: data.data.msg,
            type: "error",
          });
        }
      });
    },
    getdata() {
      this.$api
        .details({
          id: this.$route.query.id,
        })
        .then((data) => {
          console.log(data);
          if (data.data.code == 0) {
            this.works = data.data.data;
            this.list = [
              {
                name: "招聘要求",
                src: require("../static/icon_position_zp_ico.png"),
                text: this.works.recruit,
              },
              {
                name: "岗位说明",
                src: require("../static/icon_position_shuo_ico.png"),
                text: this.works.Job_description,
              },
              {
                name: "薪资福利",
                src: require("../static/icon_position_fuli_ico.png"),
                text: this.works.welfare,
              },
              {
                name: "食宿介绍",
                src: require("../static/icon_position_shi_ico.png"),
                text: this.works.introduction,
              },
            ];
          } else {
            this.$message({
              message: data.data.msg,
              type: "error",
            });
          }
        });
    },
  },
  created() {
    this.getdata();
    this.moredata();
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.texts {
  text-align: center;
}
.workdetailmo {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .work_top {
    width: 120px;
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    border-bottom: 1px solid #ce251f;
    font-size: 20px;
    color: #da251c;
    justify-content: space-between;
    margin-bottom: 30px;
    .top_img {
      width: 24px;
      height: 24px;
      // margin-right: 10px;
    }
  }
  .address {
    width: 100%;
    height: 40px;
    background: #ffffff;
    padding-left: 15px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666666;
    box-sizing: border-box;
    .icons {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
  // 头部卡片
  .detail_main {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 30px;
    .tops {
      width: 100%;
      background: #ffffff;
      padding: 30px 0;
      box-sizing: border-box;
      // display: flex;
      // align-items: center;
      .tops_div {
        width: 100%;
      }
      .tops_right {
        width: 100%;
        // padding: 20px;
        // box-sizing: border-box;
      }
      .topimg {
        width: 100%;
        height: auto;
        // margin-right: 40px;
      }
      .label_list {
        display: flex;
        align-items: center;
        margin-top: 20px;
        flex-wrap: wrap;
      }
      .labels {
        width: 80px;
        height: 30px;
        background: rgba(218, 37, 28, 0.2);
        border-radius: 6px;
        font-size: 16px;
        color: #da251c;
        text-align: center;
        line-height: 30px;
        margin-right: 10px;
      }
      .online {
        width: 120px;
        height: 50px;
        background: #da251c;
        border-radius: 6px;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
      }
      .ewms {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 14px;
        color: #333333;
        .ewm_icon {
          margin-bottom: 10px;
        }
      }
      .title {
        font-size: 24px;
        color: #333333;
        margin-top: 40px;
      }
      .money {
        font-size: 20px;
        color: #666666;
        margin-top: 40px;
        margin-bottom: 40px;
      }
      .top_foot {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        .item_left {
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #333333;
          margin-top: 30px;
          .left_icon {
            width: 16px;
            height: 18px;
            margin-right: 10px;
          }
          .more_icon {
            width: 12px;
            height: 12px;
            margin-left: 10px;
          }
        }
      }
    }
  }
  // 职位详情
  .works {
    width: 100%;
    //   height: 1019px;
    background: #ffffff;
    margin-top: 20px;
    padding: 0 30px 30px;
    box-sizing: border-box;
    .lis {
      margin-bottom: 10px;
    }
  }
  // 入职流程
  .liuc {
    width: 100%;
    background: #ffffff;
    margin-top: 40px;
    padding: 0 30px;
    box-sizing: border-box;
    .liuc_img {
      width: 100%;
      height: auto;
      margin: 10px auto 40px;
    }
    .tj_list {
      margin-top: 10px;
      margin-bottom: 40px;
      // display: flex;
      // align-items: center;
      // flex-wrap: wrap;
    }
    .tj_item {
      width: 100%;
      margin-top: 20px;
      // height: 220px;
      // background: #f7f7f7;
      // margin-right: 20px;
      // margin-top: 10px;
      cursor: pointer;
      .tj_img {
        width: 100%;
        height: auto;
      }
      .item_foot {
        padding: 0px 10px 10px;
        box-sizing: border-box;
        background: #f7f7f7;
        .name {
          font-size: 18px;
          color: #da251c;
          font-weight: bold;
        }
        .money {
          font-size: 14px;
          color: #666666;
          margin-top: 10px;
        }
      }
    }
  }
  // 报名弹窗
  .baomings {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      font-size: 22px;
      color: #da251c;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .p2 {
      color: #333333;
      font-size: 18px;
      text-align: center;
    }
    .inp {
      width: 180px;
      height: 40px;
      border: 2px solid #7d7d7d;
      border-radius: 10px;
      padding-left: 14px;
      box-sizing: border-box;
      margin-top: 20px;
    }
    .submits {
      width: 170px;
      height: 40px;
      background: #da251c;
      border-radius: 10px;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      margin-top: 20px;
      cursor: pointer;
    }
  }
}
// pc
.workdetail {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .work_top {
    width: 120px;
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    border-bottom: 1px solid #ce251f;
    font-size: 20px;
    color: #da251c;
    justify-content: space-between;
    margin-bottom: 30px;
    .top_img {
      width: 24px;
      height: 24px;
      // margin-right: 10px;
    }
  }
  .address {
    width: 100%;
    height: 40px;
    background: #ffffff;
    padding-left: 158px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666666;
    box-sizing: border-box;
    .icons {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
  // 头部卡片
  .detail_main {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 60px;
    .tops {
      width: 80%;
      background: #ffffff;
      padding: 30px;
      box-sizing: border-box;
      display: flex;
      // align-items: center;
      .topimg {
        width: 100%;
        height: 400px;
        // margin-right: 40px;
      }
      .tops_div {
        width: 40%;
        margin-right: 40px;
      }
      .tops_right {
        width: 100%;
      }
      .label_list {
        display: flex;
        align-items: center;
        margin-top: 20px;
      }
      .labels {
        width: 80px;
        height: 30px;
        background: rgba(218, 37, 28, 0.2);
        border-radius: 6px;
        font-size: 16px;
        color: #da251c;
        text-align: center;
        line-height: 30px;
        margin-right: 10px;
      }
      .online {
        width: 120px;
        height: 50px;
        background: #da251c;
        border-radius: 6px;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
      }
      .ewms {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 14px;
        color: #333333;
        .ewm_icon {
          margin-bottom: 10px;
        }
      }
      .title {
        font-size: 24px;
        color: #333333;
        margin-top: 40px;
      }
      .money {
        font-size: 20px;
        color: #666666;
        margin-top: 40px;
        margin-bottom: 40px;
      }
      .top_foot {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        .item_left {
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #333333;
          margin-top: 30px;
          .left_icon {
            width: 16px;
            height: 18px;
            margin-right: 10px;
          }
          .more_icon {
            width: 12px;
            height: 12px;
            margin-left: 10px;
          }
        }
      }
    }
  }
  // 职位详情
  .works {
    width: 80%;
    //   height: 1019px;
    background: #ffffff;
    margin-top: 20px;
    padding: 0 30px 30px;
    box-sizing: border-box;
    .lis {
      margin-bottom: 10px;
    }
  }
  // 入职流程
  .liuc {
    width: 80%;
    background: #ffffff;
    margin-top: 40px;
    padding: 0 30px;
    box-sizing: border-box;
    .liuc_img {
      width: 100%;
      height: auto;
      margin: 10px auto 40px;
    }
    .tj_list {
      margin-top: 10px;
      margin-bottom: 40px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .tj_item {
      width: 18%;
      // height: 220px;
      // background: #f7f7f7;
      margin-right: 20px;
      // margin-top: 10px;
      cursor: pointer;
      .tj_img {
        width: 100%;
        height: 160px;
      }
      .item_foot {
        padding: 0px 10px 10px;
        box-sizing: border-box;
        background: #f7f7f7;
        .name {
          font-size: 18px;
          color: #da251c;
          font-weight: bold;
        }
        .money {
          font-size: 14px;
          color: #666666;
          margin-top: 10px;
        }
      }
    }
  }
  // 报名弹窗
  .baomings {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      font-size: 36px;
      color: #da251c;
      font-weight: bold;
      margin-bottom: 40px;
    }
    .p2 {
      color: #333333;
      font-size: 24px;
    }
    .inp {
      width: 362px;
      height: 54px;
      border: 2px solid #7d7d7d;
      border-radius: 10px;
      padding-left: 14px;
      box-sizing: border-box;
      margin-top: 20px;
    }
    .submits {
      width: 340px;
      height: 40px;
      background: #da251c;
      border-radius: 10px;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      margin-top: 20px;
      cursor: pointer;
    }
  }
}
</style>
